import { getBrokenNumber } from '../../helpers/broken-number';

const FillPartClasses = {
    ACTIVE: 'active',
    QUARTER_PAST: 'quarter_past',
    HALF: 'half',
    QUARTER: 'quarter',
};

const FillIntervals = {
    ACTIVE: 0,
    QUARTER_PAST: 0.25,
    HALF: 0.5,
    QUARTER: 0.75,
    FULL: 0.8999,
};

function getStarPartClassTuple(fracPart) {
    if (fracPart >= FillIntervals.ACTIVE && fracPart < FillIntervals.QUARTER_PAST) {
        return [FillPartClasses.ACTIVE, false];
    }

    if (fracPart >= FillIntervals.QUARTER_PAST && fracPart < FillIntervals.HALF) {
        return [FillPartClasses.QUARTER_PAST, true];
    }

    if (fracPart >= FillIntervals.HALF && fracPart < FillIntervals.QUARTER) {
        return [FillPartClasses.HALF, true];
    }

    if (fracPart >= FillIntervals.QUARTER && fracPart < FillIntervals.FULL) {
        return [FillPartClasses.QUARTER, true];
    }

    return [FillPartClasses.ACTIVE, true];
}

export function getStarClassTuple(currentStarNum, userRating) {
    const { integerPart, fractionalPart } = getBrokenNumber(userRating);

    if (currentStarNum <= userRating) {
        return [FillPartClasses.ACTIVE, true];
    }

    if (currentStarNum > integerPart && currentStarNum <= Math.ceil(userRating)) {
        return getStarPartClassTuple(fractionalPart);
    }

    return [FillPartClasses.ACTIVE, false];
}
